import MarginDecoration from '../../common/components/MarginDecoration/MarginDecoration'
import PageLayout from '../../common/components/PageLayout/PageLayout'
import TextSeparator from '../../common/components/TextSeparator/TextSeparator'
import Title from '../../common/components/Title/Title'
import Expandable from './components/Expandable/Expandable'
import AllExperiments, { ExperimentSection } from './Data'
import './Experiments.css'

function Experiments () {
  const getExperimentSection = (
    experiment: ExperimentSection,
    index: number
  ) => {
    if (index !== 1) {
      return (
        <div className="experiment">
          <div className="experiment-title-main">
            <Title isMid title={experiment.title}></Title>
          </div>
          <div className="experiment-section">
            {experiment.experiments.map((experiment) => (
              <Expandable
                link={experiment.link}
                key={experiment.title}
                title={experiment.title}
              />
            ))}
          </div>
          {AllExperiments.length !== index + 1 && <TextSeparator />}
        </div>
      )
    } else {
      return (
        <div className="experiment">
          <div className="experiment-title-main">
            <Title isMid title="Antibiotics"></Title>
          </div>
          <table>
            <tr>
              <th>Name</th>
              <th>Short name</th>
              <th>Solvent</th>
              <th>Stock solution concentration (mg/mL)</th>
              <th>Working final concentration (μg/mL)</th>
            </tr>
            <tr>
              <td>Ampicillin</td>
              <td>AMP</td>
              <td>Water</td>
              <td>200</td>
              <td>100</td>
            </tr>
            <tr>
              <td>Chloramphenicol</td>
              <td>CM</td>
              <td>DMSO</td>
              <td>50</td>
              <td>20</td>
            </tr>
          </table>
          {AllExperiments.length !== index + 1 && <TextSeparator />}
        </div>
      )
    }
  }

  return (
    <PageLayout title="experiments">
      <MarginDecoration />
      <div className="experiments">
        {AllExperiments.map((experiment: ExperimentSection, index: number) =>
          getExperimentSection(experiment, index)
        )}
      </div>
    </PageLayout>
  )
}

export default Experiments
